import { setUserIsTyping } from './app-state';
import http from './http';

import { getClientInfo } from '../utils/client';
import { CONVERSATION_TYPES } from '../constants/conversations';

const TYPING_TIMEOUT_MILLIS = 10000;
const STOP_TYPING_BUFFER_MILLIS = 1000;

const lastTypingStartEvent = {};
const lastUploadedTypingStartEvent = {};
const typingTimeoutTimer = {};

export function stopTyping(convoId) {
    return (dispatch, getState) => {
        const {
            config: { appId, integrationId, typing },
            conversations,
            user,
            appState: { activeConversationId },
        } = getState();
        const conversationId = convoId || activeConversationId;
        const lastTypingStart = lastTypingStartEvent[conversationId];

        clearTimeout(typingTimeoutTimer[conversationId]);
        delete typingTimeoutTimer[conversationId];

        if (!user || !user._id || !conversationId || conversationId === 'default' || !lastTypingStart) {
            return;
        }

        const conversation = conversations[conversationId];

        if (!conversation) {
            return;
        }

        if (conversation.type === CONVERSATION_TYPES.PERSONAL && (!typing || !typing.enabled)) {
            return;
        }

        dispatch(setUserIsTyping(false));

        setTimeout(() => {
            const typingAlreadyStopped = !lastTypingStartEvent[conversationId];
            const userDidStartTyping = lastTypingStart !== lastTypingStartEvent[conversationId];

            if (!typingAlreadyStopped && !userDidStartTyping) {
                delete lastTypingStartEvent[conversationId];
                delete lastUploadedTypingStartEvent[conversationId];

                dispatch(
                    http('POST', `/v2/apps/${appId}/conversations/${conversationId}/activity`, {
                        activity: {
                            type: 'typing:stop',
                        },
                        author: {
                            appUserId: user._id,
                            role: 'appUser',
                            client: getClientInfo(integrationId),
                        },
                    }),
                );
            }
        }, STOP_TYPING_BUFFER_MILLIS);
    };
}

export function startTyping(convoId) {
    return (dispatch, getState) => {
        const {
            config: { appId, integrationId, typing },
            user,
            conversations,
            appState: { activeConversationId },
        } = getState();
        const conversationId = convoId || activeConversationId;

        if (!user || !user._id || !conversationId || conversationId === 'default') {
            return;
        }

        const conversation = conversations[conversationId];

        if (!conversation) {
            return;
        }

        if (conversation.type === CONVERSATION_TYPES.PERSONAL && (!typing || !typing.enabled)) {
            return;
        }

        lastTypingStartEvent[conversationId] = Date.now();

        dispatch(setUserIsTyping(true));

        const didUploadTypingStart = !!lastUploadedTypingStartEvent[conversationId];
        const didUploadTypingStartRecently =
            Math.abs(lastTypingStartEvent[conversationId] - lastUploadedTypingStartEvent[conversationId]) <=
            TYPING_TIMEOUT_MILLIS;

        clearTimeout(typingTimeoutTimer[conversationId]);
        typingTimeoutTimer[conversationId] = setTimeout(() => {
            dispatch(stopTyping(conversationId));
        }, TYPING_TIMEOUT_MILLIS);

        if (!didUploadTypingStart || !didUploadTypingStartRecently) {
            lastUploadedTypingStartEvent[conversationId] = lastTypingStartEvent[conversationId];

            dispatch(
                http('POST', `/v2/apps/${appId}/conversations/${conversationId}/activity`, {
                    activity: {
                        type: 'typing:start',
                    },
                    author: {
                        appUserId: user._id,
                        role: 'appUser',
                        client: getClientInfo(integrationId),
                    },
                }),
            );
        }
    };
}

export function cancelTyping() {
    return (dispatch, getState) => {
        const {
            appState: { activeConversationId },
        } = getState();

        delete lastTypingStartEvent[activeConversationId];
        delete lastUploadedTypingStartEvent[activeConversationId];

        clearTimeout(typingTimeoutTimer[activeConversationId]);
        delete typingTimeoutTimer[activeConversationId];
    };
}
